'use strict';
var wellKnownSymbol = require('../internals/well-known-symbol');

exports.f = wellKnownSymbol;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/well-known-symbol-wrapped.js
// module id = 354
// module chunks = 0